import React from "react";
import PageHeader from "../Common/PageHeader";
import EventsIcon from "../../assets/icons/Icon_Library/application icons/assets/events.svg2";
import AssetsLinks from "../Assets/AssetsLinks";
import EventsLandingPage from "./EventsLandingPage";
import HelpButton from "../HelpContent/HelpButton";

function EventsPage() {
  return (
    <div>
      {/* <PageHeader
        Icon={EventsIcon}
        heading="Events"
        subheading="Lorem, ipsum dolor sit amet consectetur adipisicing elit."
      /> */}
      {/* <AssetsLinks rightSide={undefined} /> */}
      {/* <NewFeature> */}
      <div style={{ height: 500 }}>
        <EventsLandingPage />
      </div>
      {/* </NewFeature> */}
    </div>
  );
}

export default EventsPage;
